/**
 * @generated SignedSource<<98bcc503ef368cc65b84f987b22ec887>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AnalyticsValueUnit = "duration" | "percentage" | "unit";
import { FragmentRefs } from "relay-runtime";
export type TimeSeriesOverviewItem_data$data = {
  readonly connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly avg: number | null;
        readonly formattedDate: string;
        readonly total: number | null;
      };
    }>;
  };
  readonly valueUnit: AnalyticsValueUnit;
  readonly " $fragmentType": "TimeSeriesOverviewItem_data";
};
export type TimeSeriesOverviewItem_data$key = {
  readonly " $data"?: TimeSeriesOverviewItem_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupByDimension"
    },
    {
      "kind": "RootArgument",
      "name": "timeResolution"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSeriesOverviewItem_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        },
        {
          "kind": "Variable",
          "name": "groupByDimension",
          "variableName": "groupByDimension"
        },
        {
          "kind": "Literal",
          "name": "skip",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "timeResolution",
          "variableName": "timeResolution"
        }
      ],
      "concreteType": "TimeSeriesAnalyticsConnection",
      "kind": "LinkedField",
      "name": "connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSeriesAnalyticsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSeriesAnalyticsNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formattedDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "total",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "avg",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceTimeSeriesAnalytics",
  "abstractKey": null
};

(node as any).hash = "a5a8420130e7f2bbc38454a89d72eacc";

export default node;
